import { CUSTOM_EVENTS_FOR_PERSOO } from 'modules/persoo/persooTypes';

export const createPersooEventForAddToCart = (productCatNum: string): void => {
    document.dispatchEvent(
        new CustomEvent(CUSTOM_EVENTS_FOR_PERSOO.addToCart, { bubbles: true, detail: { itemId: productCatNum } }),
    );
};
